export default __webpack_public_path__ + "atomic/_patterns/01-atoms/form-element-checkbox/_form-element-checkbox.twig";